import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, Eyebrow } from "../components/Reveal";
import { JOURNAL_ARTICLES } from "../data/journal";

export const Journal = () => (
  <section id="journal" className="bg-paper grain relative" data-testid="journal-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 py-20 lg:py-32">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-14">
        <Reveal className="lg:col-span-7">
          <Eyebrow>09 · The InSight Journal</Eyebrow>
          <h2 className="mt-6 font-serif font-medium text-forest text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight">
            Essays on metabolism, reports and real-life health.
          </h2>
        </Reveal>
        <Reveal delay={0.15} className="lg:col-span-5 lg:self-end">
          <p className="text-inkmuted leading-relaxed max-w-md lg:ml-auto">
            Written to educate, not to sell. Covering metabolism, nutrition, weight &amp; insulin resistance,
            women&rsquo;s health, gut health, lifestyle and understanding your reports.
          </p>
        </Reveal>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-line border border-line">
        {JOURNAL_ARTICLES.map((a, i) => (
          <Reveal key={a.slug} delay={0.06 * i} className="bg-white">
            <article className="p-8 h-full flex flex-col hover:bg-ivory transition-colors duration-500 group" data-testid={`journal-card-${i}`}>
              <span className="font-mono text-[10px] tracking-[0.22em] uppercase text-gold">{a.category}</span>
              <h3 className="mt-4 font-serif text-xl sm:text-2xl text-ink leading-snug flex-1 group-hover:text-forest transition-colors duration-300">
                {a.title}
              </h3>
              {a.published ? (
                <Link
                  to={`/journal/${a.slug}`}
                  data-testid={`journal-read-${a.slug}`}
                  className="mt-6 inline-flex items-center gap-2 text-[12px] font-semibold tracking-wide text-forest hover:text-gold transition-colors"
                >
                  Read the essay <ArrowRight size={13} />
                </Link>
              ) : (
                <span className="mt-6 text-[11px] font-medium tracking-wide text-inkmuted">Forthcoming essay</span>
              )}
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
